import {CssBreakpoints} from "../../CssBreakpoints";
import {SERP_INTERACTION_FLAG} from "../../SerpInteraction";
import {EmailCaptureApiCaller} from "../../EmailCaptureApiCaller";
import {DesktopModal} from "./desktop/DesktopModal";
import {ScrollAlert} from "./desktop/ScrollAlert";
import {MobileInlineComponent} from "./mobile/MobileInlineComponent";
import {BottomModal} from "./mobile/BottomModal";

export class EmailCaptureOrchestrator {
    private readonly apiCaller: EmailCaptureApiCaller;
    private readonly desktopModal: DesktopModal;
    private readonly mobileInline: MobileInlineComponent;
    private readonly bottomModal: BottomModal;
    private readonly scrollAlert: ScrollAlert;

    constructor() {
        this.apiCaller = new EmailCaptureApiCaller();
        this.desktopModal = new DesktopModal(this.apiCaller);
        this.mobileInline = new MobileInlineComponent(this.apiCaller);
        this.bottomModal = new BottomModal(this.apiCaller);
        this.scrollAlert = new ScrollAlert();
    }

    init(): void {
        if (this.desktopModal.isAvailable()) {
            this.desktopModal.init();
            this.desktopModal.onSuccess(() => this.scrollAlert.dismiss());
        }

        if (this.mobileInline.isAvailable()) {
            this.mobileInline.init();
        }

        if (this.bottomModal.isAvailable() && this.isMobile()) {
            this.bottomModal.init();
            this.bottomModal.initAutoShow();
            this.bottomModal.onSuccess(() => this.mobileInline.hide());
            this.bottomModal.onDismiss(() => this.mobileInline.hide());
        }

        if (this.scrollAlert.isAvailable() && !this.isMobile()) {
            this.scrollAlert.init();
            this.scrollAlert.onButtonClick(() => this.desktopModal.show());
        }

        this.checkInteractionFlag();
    }

    private checkInteractionFlag(): void {
        const interactionType = sessionStorage.getItem(SERP_INTERACTION_FLAG);
        if (interactionType) {
            sessionStorage.removeItem(SERP_INTERACTION_FLAG);
            setTimeout(() => {
                if (this.isMobile()) {
                    this.bottomModal.show();
                } else {
                    this.desktopModal.show();
                }
            }, 500);
        }
    }

    private isMobile(): boolean {
        return !CssBreakpoints.get().isDesktop();
    }
}

export default EmailCaptureOrchestrator;
